import sysEnv from '@/env/envs'

import {
  mapStyle1,
  mapStyle2
} from './map_style'

export const pointChange = (point) => {
  let ggLng = point[0]
  let ggLat = point[1]
  let XPI = Math.PI * 3000.0 / 180.0
  let z = Math.sqrt(ggLng * ggLng + ggLat * ggLat) + 0.00002 * Math.sin(ggLat * XPI)
  let theta = Math.atan2(ggLat, ggLng) + 0.000003 * Math.cos(ggLng * XPI)
  let bdLng = z * Math.cos(theta) + 0.0065
  let bdLat = z * Math.sin(theta) + 0.006
  return [bdLng, bdLat]
}

let adr = window.location.host

export const mapXzqh = function (map, xzqhNames, dealFun, hoverFun, mapType, mapHotType, mapHotColorType, isCc) {
  mapType = mapType || 'norm'
  xzqhNames.forEach((item) => {
    let bdary = new window.BMap.Boundary()
    bdary.get(item.name, function (rs) {
      if (item.name === '云南省') {
        mapXzOutBak(map, rs.boundaries)
      }
      let boundaries = rs.boundaries
      if (boundaries.length !== 0) {
        mapXzqhHz(map, item, boundaries, dealFun, hoverFun, mapType, mapHotType, mapHotColorType, isCc)
      }
    })
  })
}

export const mapXzqh2 = function (map, xzqhNames, dealFun, hoverFun) {
  xzqhNames.forEach((item) => {
    let bdary = new window.BMap.Boundary()
    bdary.get(item.name, function (rs) {
      let boundaries = rs.boundaries
      if (boundaries.length !== 0) {
        mapXzqhHz2(map, item, boundaries, dealFun, hoverFun)
      }
    })
  })
}

// let colors = ['#e47516', '#ed9000', '#f4a500', '#fbc000', '#f5e000']
let fColors = ['#d85e23', '#f9d560', '#93c672', '#04a2c2', '#575fae']
// let colors = ['#b80100', '#c6451d', '#d98a3f', '#f3cc57', '#fff067']
let sColors = ['#c9322d', '#d46a44', '#e1a161', '#f1d16d', '#fef37d']

let getShiColorBySeal = function (seal, colors) {
  let color = colors[4]
  if (seal > 200000) {
    color = colors[0]
  } else if (seal > 150000) {
    color = colors[1]
  } else if (seal > 100000) {
    color = colors[2]
  } else if (seal > 50000) {
    color = colors[3]
  }
  return color
}

let getShiColorBySealZb = function (seal, colors) {
  let color = colors[4]
  if (seal > 0.5) {
    color = colors[0]
  } else if (seal > 0.4) {
    color = colors[1]
  } else if (seal > 0.3) {
    color = colors[2]
  } else if (seal > 0.2) {
    color = colors[3]
  }
  return color
}

let getShiColorBySealTb = function (seal, colors) {
  let color = colors[4]
  if (seal > 0.3) {
    color = colors[0]
  } else if (seal > 0.2) {
    color = colors[1]
  } else if (seal > 0.1) {
    color = colors[2]
  } else if (seal > 0) {
    color = colors[3]
  }
  return color
}

let getShiColorBySealHb = function (seal, colors) {
  let color = colors[0]
  if (seal > 1) {
    color = colors[4]
  }
  return color
}

export const xzqhStyleConfig = {
  norm: {
    strokeWeight: 1,
    fillOpacity: 0.02,
    fillColor: '#f39700',
    strokeColor: '#999'
  },
  hoverShi: {
    strokeWeight: 3,
    fillOpacity: 0.15
  },
  activeShi: {
    strokeWeight: 3,
    fillOpacity: 0.08,
    strokeColor: '#f39700'
  }
}

export const xzqhStyleConfig2 = {
  norm: {
    strokeWeight: 1,
    fillOpacity: 0.02,
    fillColor: '#008c90',
    strokeColor: '#fff'
  },
  hoverShi: {
    strokeWeight: 3,
    fillOpacity: 0.3
  },
  activeShi: {
    strokeWeight: 3,
    fillOpacity: 0.2,
    strokeColor: '#008c90'
  }
}

const mapXzOutBak = function (map, boundaries) {
  let points = ['180, -90', '180, 90', '-180, 90', '-180, -90', '180, -90']
  let boundariesList = boundaries[0].split(';')
  let boundarieList = [boundariesList[0]].concat(points)
  boundarieList.push(boundariesList[0])
  boundarieList = boundarieList.concat(boundariesList.slice(1, boundariesList.length))
  let boundarie = boundarieList.join(';')
  let ply = new window.BMap.Polygon(boundarie, {
    strokeWeight: 1,
    strokeOpacity: 0.9,
    enableClicking: false,
    strokeColor: '#f0f0f0',
    fillOpacity: 1,
    fillColor: '#f0f0f0'
  })
  map.addOverlay(ply)
}

const mapXzqhHz = function (map, area, boundaries, dealFun, hoverFun, mapType, mapHotType, mapHotColorType, isCc) {
  let colors = mapHotColorType === 1 ? fColors : sColors
  let areaName = area.name
  let i = 0
  let plyList = []
  let pointArray = []
  while (i < boundaries.length) {
    let fillColor = xzqhStyleConfig.norm.fillColor
    if (mapType === 'ls' && area.level === 'shi') {
      let color = '#fff'
      if (mapHotType === 'xl') {
        color = getShiColorBySeal(area.value, colors)
      } else if (mapHotType === 'sczb') {
        color = getShiColorBySealZb(area.value2, colors)
      } else if (mapHotType === 'tb') {
        color = getShiColorBySealTb(area.valueTb, colors)
      } else if (mapHotType === 'hb') {
        color = getShiColorBySealHb(area.valueHb, colors)
      }
      fillColor = mapHotType ? color : '#fff'
    }
    if (area.level === 'sheng') {
      fillColor = isCc ? '#4ea2d6' : '#fff'
    }
    let fillOpacity = xzqhStyleConfig.norm.fillOpacity
    if (mapType === 'main' && area.level === 'qx') {
      fillOpacity = area.value / 2 || 0.01
    }
    if (mapType === 'ls' && area.level === 'shi') {
      fillOpacity = mapHotType ? (mapHotColorType === 1 ? 0.2 : 1) : 0.01
    }
    let shengOpacity = isCc ? 0.05 : 0.00001
    let ply = new window.BMap.Polygon(boundaries[i], {
      strokeWeight: area.level === 'sheng' ? 1 : xzqhStyleConfig.norm.strokeWeight,
      strokeColor: mapHotColorType === 1 ? xzqhStyleConfig.norm.strokeColor : '#f0f0f0',
      fillOpacity: area.level === 'sheng' ? shengOpacity : fillOpacity,
      fillColor: fillColor,
      strokeStyle: area.level === 'qx' ? 'dashed' : 'solid'
    })
    map.addOverlay(ply)
    let maxLat = 0
    let minLat = 1000
    let maxLng = 0
    let minLng = 1000
    ply.getPath().forEach((item) => {
      if (item.lat < minLat) {
        minLat = item.lat
      }
      if (item.lat > maxLat) {
        maxLat = item.lat
      }
      if (item.lng < minLng) {
        minLng = item.lng
      }
      if (item.lng > maxLng) {
        maxLng = item.lng
      }
    })
    pointArray = [new window.BMap.Point(maxLng, minLat), new window.BMap.Point(minLng, maxLat)]
    ply.addEventListener('mouseover', function (parm) {
      // hoverFun(area, ply)
    })
    ply.addEventListener('mouseout', function (parm) {
      // if (!ply.getBounds().containsPoint(parm.point)) {
      // hoverFun(area, ply, true)
      // }
    })
    plyList.push(ply)
    i += 1
  }
  dealFun({
    name: areaName,
    hzOk: true,
    level: area.level,
    plyList,
    pointArray
  })
}

const mapXzqhHz2 = function (map, area, boundaries, dealFun, hoverFun) {
  let areaName = area.name
  let i = 0
  let plyList = []
  let pointArray = []
  while (i < boundaries.length) {
    let ply = new window.BMap.Polygon(boundaries[i], {
      strokeWeight: xzqhStyleConfig2.norm.strokeWeight,
      strokeColor: xzqhStyleConfig2.norm.strokeColor,
      fillOpacity: xzqhStyleConfig2.norm.fillOpacity,
      fillColor: xzqhStyleConfig2.norm.fillColor,
      strokeStyle: area.level === 'qx' ? 'dashed' : 'solid'
    })
    map.addOverlay(ply)
    let maxLat = 0
    let minLat = 1000
    let maxLng = 0
    let minLng = 1000
    ply.getPath().forEach((item) => {
      if (item.lat < minLat) {
        minLat = item.lat
      }
      if (item.lat > maxLat) {
        maxLat = item.lat
      }
      if (item.lng < minLng) {
        minLng = item.lng
      }
      if (item.lng > maxLng) {
        maxLng = item.lng
      }
    })
    pointArray = [new window.BMap.Point(maxLng, minLat), new window.BMap.Point(minLng, maxLat)]
    ply.addEventListener('mouseover', function (data, data2, data3) {
      hoverFun(area, ply)
    })
    ply.addEventListener('mouseout', function () {
      hoverFun(area, ply, true)
    })
    plyList.push(ply)
    i += 1
  }
  dealFun({
    name: areaName,
    hzOk: true,
    level: area.level,
    plyList,
    pointArray
  })
}

export const setMapViewport = function (map, pointArray) {
  map.setViewport(pointArray, {
    delay: 100,
    enableAnimation: true
  })
}

export const initGasOption = function (getSizeFun, seriesData = [], tooltipF, selectLegend) {
  let defFun = (data) => {
    return 8
  }
  document.body.onmousemove = function () {
    if (window.tooltipDom) {
      window.tooltipDom.style = 'display: none;'
    }
  }
  getSizeFun = getSizeFun || defFun
  let legendData = [sysEnv.zsyName, '中石化', '社会站', '油库', sysEnv.zsyName + '管道', '中石化管道', '铁路']
  let option = {}
  option.bmap = {
    center: [101.313408, 25.069329],
    zoom: 8,
    roam: true,
    mapStyle: {
      styleJson: mapStyle1
    }
  }
  option.brush = {
    outOfBrush: {
      color: '#abc'
    },
    brushStyle: {
      borderWidth: 2,
      color: 'rgba(0,0,0,0.2)',
      borderColor: 'rgba(0,0,0,0.5)'
    },
    throttleType: 'debounce',
    geoIndex: 0
  }
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 20,
    right: 20,
    data: legendData,
    selected: {},
    textStyle: {
      color: '#666',
      fontSize: 15
    },
    itemWidth: 15
  }]
  for (let key in selectLegend) {
    option.legend[0].selected[key] = selectLegend[key]
  }
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  }
  option.series = [{
    id: 'gas_zsy_warning',
    type: 'effectScatter',
    name: sysEnv.zsyName + '预警',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data) / 2 + 8
    },
    rippleEffect: {
      period: 2,
      scale: 4
    },
    data: seriesData[7] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ea0000'
      }
    },
    z: 1
  },
  {
    id: 'gas_zsh',
    name: '中石化',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/logo_zsh.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data) + 5
    },
    data: seriesData[1] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#666'
      }
    },
    z: 3
  },
  {
    id: 'gas_zy',
    name: '社会站',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/logo_ql.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data) + 3
    },
    data: seriesData[2] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#5998fe'
      }
    },
    z: 2
  },
  {
    id: 'gas_zsy',
    type: 'scatter',
    name: sysEnv.zsyName,
    symbol: 'image://http://' + adr + '/static/logo_zsy.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data)
    },
    data: seriesData[0] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ed8503'
      }
    },
    z: 4
  },
  {
    id: 'depot',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun()
    },
    data: seriesData[3] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa'
      }
    }
  },
  {
    id: 'pipe',
    name: sysEnv.zsyName + '管道',
    type: 'lines',
    polyline: true,
    coordinateSystem: 'bmap',
    data: seriesData[4] || [],
    effect: {
      show: true,
      symbolSize: 8,
      color: '#ed8503',
      period: 20,
      trailLength: 0
    },
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#ed8503',
        width: 3,
        opacity: 1
      },
      emphasis: {
        color: '#ed8503',
        width: 3,
        opacity: 1
      }
    },
    z: 3
  },
  {
    id: 'pipe_bak',
    name: sysEnv.zsyName + '管道',
    type: 'lines',
    polyline: true,
    coordinateSystem: 'bmap',
    data: seriesData[4] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#666',
        width: 6,
        opacity: 0.8,
        curveness: 0.5
      },
      emphasis: {
        color: '#666',
        width: 6,
        opacity: 0.8,
        curveness: 0.5
      }
    },
    z: 1
  },
  {
    id: 'pipe2',
    name: '中石化管道',
    type: 'lines',
    polyline: true,
    coordinateSystem: 'bmap',
    data: seriesData[5] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    effect: {
      show: true,
      period: 20,
      symbolSize: 8,
      color: '#eee',
      trailLength: 0
    },
    lineStyle: {
      normal: {
        color: '#efefef',
        width: 3,
        opacity: 1
      },
      emphasis: {
        color: '#efefef',
        width: 3,
        opacity: 1
      }
    }
  },
  {
    id: 'pipe2_bak',
    name: '中石化管道',
    type: 'lines',
    polyline: true,
    coordinateSystem: 'bmap',
    data: seriesData[5] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#666',
        width: 6,
        opacity: 0.8
      },
      emphasis: {
        color: '#666',
        width: 6,
        opacity: 0.8
      }
    },
    z: 1
  },
  {
    id: 'railway',
    name: '铁路',
    type: 'lines',
    polyline: true,
    large: true,
    coordinateSystem: 'bmap',
    data: seriesData[6] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    effect: {
      show: true,
      symbolSize: 8,
      period: 20,
      color: '#666',
      trailLength: 0
    },
    lineStyle: {
      normal: {
        color: '#333',
        type: 'dashed',
        width: 3,
        opacity: 0.8
      },
      emphasis: {
        color: '#333',
        type: 'dashed',
        width: 3,
        opacity: 0.8
      }
    },
    z: 3
  },
  {
    id: 'railway_bak',
    name: '铁路',
    type: 'lines',
    polyline: true,
    large: true,
    coordinateSystem: 'bmap',
    data: seriesData[6] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#ffffff',
        width: 3,
        opacity: 0.8
      },
      emphasis: {
        color: '#ffffff',
        width: 3,
        opacity: 0.8
      }
    },
    z: 1
  }]
  option.tooltip = {
    trigger: 'item',
    position: function (point, params, dom, rect, size) {
      window.tooltipDom = dom
      setTimeout(function () {
        dom.style = 'position: absolute; display: block; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1); background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font-style: normal; font-variant: normal; font-weight: normal; font-stretch: normal; font-size: 14px; font-family: sans-serif; line-height: 21px; padding: 5px; left: ' + (point[0] + 26) + 'px; top: ' + (point[1] + 4) + 'px;'
      }, 200)
      return {left: point[0], top: point[1]}
    },
    formatter: tooltipF
  }
  return option
}

export const initGasOptionNew = function (getSizeFun, seriesData = [], tooltipF, selectLegend, mapConfig, showDepotLabel) {
  let defFun = (data) => {
    return 8
  }
  document.body.onmousemove = function () {
    if (window.tooltipDom) {
      window.tooltipDom.style = 'display: none;'
    }
  }
  getSizeFun = getSizeFun || defFun
  let legendData = []
  for (let key in selectLegend) {
    legendData.push(key)
  }
  let option = {}
  option.bmap = {
    center: mapConfig ? mapConfig.ponit : [101.313408, 25.069329],
    zoom: mapConfig ? mapConfig.zoom : 7,
    roam: true,
    mapStyle: {
      styleJson: mapStyle1
    }
  }
  // option.brush = {
  //   outOfBrush: {
  //     color: '#abc'
  //   },
  //   brushStyle: {
  //     borderWidth: 2,
  //     color: 'rgba(0,0,0,0.2)',
  //     borderColor: 'rgba(0,0,0,0.5)'
  //   },
  //   throttleType: 'debounce',
  //   geoIndex: 0
  // }
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 5,
    right: 5,
    data: legendData,
    selected: {},
    textStyle: {
      color: '#fff',
      fontSize: 12
    },
    itemWidth: 12,
    show: false
  }]
  for (let key in selectLegend) {
    option.legend[0].selected[key] = selectLegend[key]
  }
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  }
  option.series = [{
    id: 'gas_zsy_warning',
    type: 'effectScatter',
    name: sysEnv.zsyName + '预警',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data) / 2 + 8
    },
    rippleEffect: {
      period: 2,
      scale: 4
    },
    data: seriesData[7] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ea0000'
      }
    },
    z: 5
  },
  {
    id: 'gas_zsy_warning_2',
    name: sysEnv.zsyName + '预警',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/logo_zsy.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data) / 2 + 8
    },
    data: seriesData[7] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#666'
      }
    },
    z: 6
  },
  {
    id: 'gas_zsh',
    name: '中石化',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/logo_zsh.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data) + 5
    },
    data: seriesData[1] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#666'
      }
    },
    z: 3
  },
  {
    id: 'gas_zy',
    name: '社会站',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/logo_ql.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data) + 3
    },
    data: seriesData[2] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#5998fe'
      }
    },
    z: 2
  },
  {
    id: 'gas_zsy',
    type: 'scatter',
    name: sysEnv.zsyName,
    symbol: 'image://http://' + adr + '/static/logo_zsy.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data)
    },
    data: seriesData[0] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ed8503'
      }
    },
    z: 4
  },
  {
    id: 'depot_zsy_gd',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku_zsy_1.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2)
    },
    data: seriesData[3] || [],
    tooltip: {
      show: !showDepotLabel
    },
    label: {
      normal: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        distance: 0,
        color: '#444',
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      },
      emphasis: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        color: '#444',
        distance: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa',
        opacity: 1
      }
    },
    z: 5
  },
  {
    id: 'depot_zsy_tl',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku_zsy_2.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2)
    },
    tooltip: {
      show: !showDepotLabel
    },
    data: seriesData[14] || [],
    label: {
      normal: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        distance: 0,
        color: '#444',
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      },
      emphasis: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        color: '#444',
        distance: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa',
        opacity: 1
      }
    },
    z: 5
  },
  {
    id: 'depot_zsy_df',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku_zsy_3.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2) * 0.8
    },
    tooltip: {
      show: !showDepotLabel
    },
    data: seriesData[15] || [],
    label: {
      normal: {
        position: 'top',
        show: showDepotLabel,
        formatter: '{b}',
        distance: 0,
        color: '#444',
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      },
      emphasis: {
        position: 'top',
        show: showDepotLabel,
        formatter: '{b}',
        color: '#444',
        distance: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa',
        opacity: 1
      }
    },
    z: 6
  },
  {
    id: 'depot_zsh',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku_zsh.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2)
    },
    tooltip: {
      show: !showDepotLabel
    },
    data: seriesData[10] || [],
    label: {
      normal: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        distance: 0,
        color: '#444',
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      },
      emphasis: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        color: '#444',
        distance: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa',
        opacity: 1
      }
    },
    z: 5
  },
  {
    id: 'depot_gc',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku_other.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2)
    },
    tooltip: {
      show: !showDepotLabel
    },
    data: seriesData[11] || [],
    label: {
      normal: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        distance: 0,
        color: '#444',
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      },
      emphasis: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        color: '#444',
        distance: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa',
        opacity: 1
      }
    },
    z: 5
  },
  {
    id: 'depot_zhy',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku_other.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2)
    },
    tooltip: {
      show: !showDepotLabel
    },
    data: seriesData[12] || [],
    label: {
      normal: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        distance: 0,
        color: '#444',
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      },
      emphasis: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        color: '#444',
        distance: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa',
        opacity: 1
      }
    },
    z: 5
  },
  {
    id: 'depot_sh',
    name: '油库',
    type: 'scatter',
    symbol: 'image://http://' + adr + '/static/youku_other.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2)
    },
    tooltip: {
      show: !showDepotLabel
    },
    data: seriesData[13] || [],
    label: {
      normal: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        distance: 0,
        color: '#444',
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      },
      emphasis: {
        position: 'bottom',
        show: showDepotLabel,
        formatter: '{b}',
        color: '#444',
        distance: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
        padding: [3, 5, 3, 5]
      }
    },
    itemStyle: {
      normal: {
        color: '#345baa',
        opacity: 1
      }
    },
    z: 5
  },
  {
    id: 'pipe',
    name: '管道',
    type: 'lines',
    polyline: true,
    coordinateSystem: 'bmap',
    data: seriesData[4] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#cd3019',
        width: 3,
        opacity: 1
      },
      emphasis: {
        color: '#cd3019',
        width: 3,
        opacity: 1
      }
    },
    z: 3
  },
  {
    id: 'pipe2',
    name: '管道',
    type: 'lines',
    polyline: true,
    coordinateSystem: 'bmap',
    data: seriesData[5] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#00a7ff',
        width: 3,
        opacity: 1
      },
      emphasis: {
        color: '#00a7ff',
        width: 3,
        opacity: 1
      }
    }
  },
  {
    id: 'railway',
    name: '铁路',
    type: 'lines',
    polyline: true,
    large: true,
    coordinateSystem: 'bmap',
    data: seriesData[6] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#000',
        type: 'dashed',
        width: 2,
        opacity: 0.8
      },
      emphasis: {
        color: '#000',
        type: 'dashed',
        width: 2,
        opacity: 0.8
      }
    },
    z: 3
  },
  {
    id: 'railway_d',
    name: '铁路',
    type: 'lines',
    polyline: true,
    large: true,
    coordinateSystem: 'bmap',
    data: seriesData[6] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    // effect: {
    //   show: true,
    //   symbolSize: 8,
    //   period: 20,
    //   color: '#666',
    //   trailLength: 0
    // },
    lineStyle: {
      normal: {
        color: '#000',
        width: 3,
        opacity: 0.8
      },
      emphasis: {
        color: '#000',
        width: 3,
        opacity: 0.8
      }
    },
    z: 1
  },
  {
    id: 'railway_bak',
    name: '铁路',
    type: 'lines',
    polyline: true,
    large: true,
    coordinateSystem: 'bmap',
    data: seriesData[6] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    lineStyle: {
      normal: {
        color: '#ffffff',
        width: 2,
        opacity: 1
      },
      emphasis: {
        color: '#ffffff',
        width: 2,
        opacity: 1
      }
    },
    z: 2
  }]
  option.tooltip = {
    trigger: 'item',
    position: function (point, params, dom, rect, size) {
      window.tooltipDom = dom
      let wkey = 'left'
      let hkey = 'top'
      let position = {}
      if (point[0] > size.viewSize[0] / 2) {
        wkey = 'right'
        position[wkey] = size.viewSize[0] - point[0]
      } else {
        position[wkey] = point[0]
      }
      if (point[1] > size.viewSize[1] / 2) {
        hkey = 'bottom'
        position[hkey] = size.viewSize[1] - point[1]
      } else {
        position[hkey] = point[1]
      }
      setTimeout(function () {
        dom.style = 'position: absolute; display: block; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1); background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font-style: normal; font-variant: normal; font-weight: normal; font-stretch: normal; font-size: 14px; font-family: sans-serif; line-height: 21px; padding: 5px; ' + wkey + ': ' + (position[wkey] + 26) + 'px; ' + hkey + ': ' + (position[hkey] + 4) + 'px;'
      }, 200)
      return position
    },
    formatter: tooltipF
  }
  return option
}

export const initGasOption2 = function (getSizeFun, seriesData = [], tooltipF) {
  let defFun = (data) => {
    return 8
  }
  document.body.onmousemove = function () {
    if (window.tooltipDom) {
      window.tooltipDom.style = 'display: none;'
    }
  }
  getSizeFun = getSizeFun || defFun
  let option = {}
  option.bmap = {
    center: [101.6, 24.9],
    zoom: 9,
    roam: true,
    mapStyle: {
      styleJson: mapStyle2
    }
  }
  option.brush = {
    outOfBrush: {
      color: '#abc'
    },
    brushStyle: {
      borderWidth: 2,
      color: 'rgba(0,0,0,0.2)',
      borderColor: 'rgba(0,0,0,0.5)'
    },
    throttleType: 'debounce',
    geoIndex: 0
  }
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  }
  option.series = [{
    id: 'gas_zsy',
    type: 'scatter',
    name: sysEnv.zsyName,
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data)
    },
    data: seriesData[0] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#f4ed00'
      }
    }
  },
  {
    id: 'gas_zsh',
    type: 'effectScatter',
    name: sysEnv.zsyName,
    rippleEffect: {
      scale: 4
    },
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data)
    },
    data: seriesData[1] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#f4ed00'
      }
    }
  }]
  option.tooltip = {
    trigger: 'item',
    position: function (point, params, dom, rect, size) {
      window.tooltipDom = dom
      setTimeout(function () {
        dom.style = 'position: absolute; display: block; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1); background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font-style: normal; font-variant: normal; font-weight: normal; font-stretch: normal; font-size: 14px; font-family: sans-serif; line-height: 21px; padding: 5px; left: ' + (point[0] + 26) + 'px; top: ' + (point[1] + 4) + 'px;'
      }, 200)
      return {left: point[0], top: point[1]}
    },
    formatter: tooltipF
  }
  return option
}

export const initGasOptionGasTankWarning = function (getSizeFun, seriesData = []) {
  let defFun = (data) => {
    return 8
  }
  document.body.onmousemove = function () {
    if (window.tooltipDom) {
      window.tooltipDom.style = 'display: none;'
    }
  }
  getSizeFun = getSizeFun || defFun
  let option = {}
  option.bmap = {
    center: [102.73, 25.04],
    zoom: 7,
    roam: true
  }
  option.series = [{
    id: 'gas_zsy',
    type: 'effectScatter',
    name: sysEnv.zsyName,
    symbol: 'image://http://' + adr + '/static/logo_zsy.png',
    coordinateSystem: 'bmap',
    symbolSize: (data, data2) => {
      return getSizeFun(data2.data.data)
    },
    data: seriesData[0] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ed8503'
      }
    }
  },
  {
    id: 'car',
    type: 'scatter',
    name: '油罐车',
    symbol: 'image://http://' + adr + '/static/car.png',
    coordinateSystem: 'bmap',
    symbolSize: 25,
    data: seriesData[1] || [],
    label: {
      normal: {
        position: 'right',
        show: false
      }
    }
  }]
  option.tooltip = {
    trigger: 'item',
    position: function (point, params, dom, rect, size) {
      window.tooltipDom = dom
      setTimeout(function () {
        dom.style = 'position: absolute; display: block; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1); background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font-style: normal; font-variant: normal; font-weight: normal; font-stretch: normal; font-size: 14px; font-family: sans-serif; line-height: 21px; padding: 5px; left: ' + (point[0] + 26) + 'px; top: ' + (point[1] + 4) + 'px;'
      }, 200)
      return {left: point[0], top: point[1]}
    },
    formatter: function (data) {
      let valueMap = data.data.data
      let text = ''
      if (valueMap.gasName) {
        text = valueMap.gasName + ' - ' + valueMap.tankMark + '罐<br/>' + valueMap.oilName + '<br/>' + valueMap.warningText
      } else {
        text = valueMap.carId + '<br/>' + valueMap.status + ' -> ' + valueMap.stop
      }
      return text
    }
  }
  return option
}

export const updateMapCenterAndZoom = function (map, center, zoom) {
  map.centerAndZoom(new window.BMap.Point(center[0], center[1]), zoom)
}

export const addEvent = function (chart, event, dealFun) {
  chart.on(event, function (params) {
    dealFun(params)
  })
}

export const setDataGasOption = function (chart, key, data) {
  chart.setOption({
    series: {
      id: key,
      data: data,
      type: key === 'gas_zsy_tx' ? 'effectScatter' : 'scatter'
    }
  }, true)
}



// WEBPACK FOOTER //
// ./src/cllib/mapTools.js